import { useSearchParams } from "react-router-dom";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { SignupForm, InquiryForm } from "@/components/Forms";
import { useSite } from "@/lib/SiteContext";

export default function Connect() {
  const { settings } = useSite();
  const [params] = useSearchParams();
  const category = ["general", "speaking", "media", "bulk"].includes(params.get("category"))
    ? params.get("category")
    : "general";

  return (
    <div className="bg-ink min-h-screen" data-testid="connect-page">
      <Seo title="Connect — Dirty Church Chronicles"
        description="Join the reader list or send a speaking, media, or bulk-copy inquiry to the Dirty Church Chronicles team."
        path="/connect" />
      <section className="pt-40 pb-24 max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal>
          <p className="eyebrow mb-4">Connect</p>
          <h1 className="font-display font-black uppercase text-paper text-4xl sm:text-6xl tracking-tight mb-4">
            Stay Close to the Work
          </h1>
          <p className="font-reading text-xl text-paper/70 max-w-2xl mb-20">
            Join the reader list, or reach the team about speaking, media, and bulk copies.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <Reveal className="border border-paper/10 bg-coal p-8 sm:p-12" data-testid="connect-signup-card">
            <SignupForm heading={settings.signup_heading} body={settings.signup_body} />
          </Reveal>
          <Reveal delay={0.12} data-testid="connect-inquiry-card">
            <h2 className="font-display text-2xl sm:text-3xl text-paper mb-3">Send an Inquiry</h2>
            <p className="font-ui text-sm text-paper/50 mb-8">
              Speaking engagements, media and press, bulk copies, or general questions.
            </p>
            <InquiryForm defaultCategory={category} />
          </Reveal>
        </div>
        {settings.contact_email && (
          <Reveal delay={0.2}>
            <p className="font-ui text-sm text-paper/50 mt-16">
              Prefer email? Write to{" "}
              <a href={`mailto:${settings.contact_email}`} data-testid="connect-email-link"
                className="text-crimsonhi underline underline-offset-4">
                {settings.contact_email}
              </a>
            </p>
          </Reveal>
        )}
      </section>
    </div>
  );
}
